<template>
  <div class="service-section page pod-page">
    <div class="service-grid">
      <!-- 循环渲染6个服务卡片 -->
      <div
        class="service-card"
        v-for="(item, index) in serviceList"
        :key="index"
      >
        <!-- 左侧图标圆圈 + 右侧序号标题 -->
        <div class="card-header">
          <div class="icon-circle">
            <i class="iconfont">{{ item.icon }}</i>
          </div>
          <div class="title-wrap">
            <div class="num">{{ item.num }}</div>
            <h3 class="title">{{ item.title }}</h3>
            <div class="line"></div>
            <!-- 描述文本 -->
            <p class="desc">{{ item.desc }}</p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceGrid",
  data() {
    return {
      serviceList: [
        {
          num: "01",
          title: "Product Sourcing",
          icon: "🔍", // 可替换为真实图标库图标
          desc: "Source customizable products with 24-48h matching via China supply chain."
        },
        {
          num: "02",
          title: "Custom Production",
          icon: "👕",
          desc: "UV, laser, DTF/CVT, embroidery & more based on product type."
        },
        {
          num: "03",
          title: "Personalization & Branding",
          icon: "🏷️",
          desc: "Logo printing, private label & customized packaging included."
        },
        {
          num: "04",
          title: "Quality Control",
          icon: "🛡️",
          desc: "Strict inspection before every shipment."
        },
        {
          num: "05",
          title: "Global Fulfillment",
          icon: "🚚",
          desc: "API-synced orders with full production-to-delivery tracking."
        },
        {
          num: "06",
          title: "24/7 Support",
          icon: "🎧",
          desc: "24/7 order monitoring & fast issue resolution."
        }
      ]
    }
  }
}
</script>

<style scoped>
.service-section {
  padding: 30px 0px;
  background-color: #f8fafc;
}
.service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 0 auto;
}
.service-card {
  background: #ffffff;
  padding: 24px 20px;
  border-radius: 12px;
  box-shadow: 0 14px 36px rgba(12, 41, 88, 0.12);
}
.card-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 12px;
}
.icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #eff6ff;
  color: #2563eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  .iconfont{
    font-size: 36px;
    font-style:normal;
  }
}
.title-wrap .num {
  color: #2563eb;
  font-weight: 600;
  font-size: 16px;
}
.title-wrap .title {
  margin: 4px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}
.title-wrap .line{
  height:4px;width:45px;background-color:#2563eb;
  margin:6px 0;
}
.title-wrap  .desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}
.vi-section-title-wrap {
  text-align: center;
  padding:24px;
}

.vi-big-title {
  font-size: 48px;
  font-weight: bold;
  color: #000000;
  margin: 0 0 18px;
  line-height: 1.25;
}

.vi-blue-desc {
  font-size: 32px;
  color: #0066ff;
  margin: 0;
  line-height: 1.3;
}
/* 响应式适配：平板2列、手机1列 */
@media (max-width: 768px) {
  .vi-big-title {
    font-size: 34px;
  }
  .vi-blue-desc {
    font-size: 22px;
  }
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .service-grid {
    grid-template-columns:repeat(2, 1fr);
    gap:10px;
  }
  .icon-circle{
    display:none;
  }
  .vi-big-title {
    font-size: 26px;
  }
  .vi-blue-desc {
    font-size: 17px;
  }
}
</style>